// extracted by mini-css-extract-plugin
export default {"gridContainer":"CompoundTags_gridContainer__Eemjh"};